import { Button, Form, Input, Modal, Select } from "antd";
import { useMutation, useQueryClient } from "react-query";
import { createRate, updateRate } from "../../api/rate";
import { showErrorToast, showSuccessToast } from "../../utils/toast";
import { useEffect, useState } from "react";
import { useForm } from "antd/es/form/Form";
import UploadImages from "../products/upload";
import { addCategories, updateCategories } from "../../api/product";

const CategoryModal = ({ open = false, setOpen, data }) => {
  const queryClient = useQueryClient();
  const [form] = useForm();

  const [images, setImages] = useState([]);

  const mutation = useMutation(data ? updateCategories : addCategories, {
    onSuccess: () => {
      queryClient.invalidateQueries("categories");
      showSuccessToast(
        data ? "Category updated" : "Category added successfully"
      );
      setOpen(false);
    },
    onError: (e) => {
      showErrorToast(e.message);
    },
  });

  const onFinish = (values) => {
    console.log(values, images);
    mutation.mutate({
      ...(data && { id: data?._id }),
      ...values,
      category_image: images[0],
    });
  };

  useEffect(() => {
    if (data) {
      form.setFields(
        Object.keys(data).map((key) => ({ name: key, value: data[key] }))
      );
    }
  }, [data]);

  return (
    <Modal
      title="Add Category"
      open={open}
      footer={null}
      onCancel={() => setOpen(false)}
    >
      <UploadImages setImages={setImages} maxLength={1} />
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item name="name" label="Name">
          <Input />
        </Form.Item>

        <Form.Item name="description" label="Description">
          <Input.TextArea rows={5} />
        </Form.Item>

        <Form.Item name="subcategory" label="Sub Category">
          <Select
            mode="tags"
            // style={{ width: "100%" }}
            placeholder="Enter multiple sub categories"
            // onChange={handleChange}
            options={[]}
          />
        </Form.Item>

        <Button
          className="bg-dark text-white rounded-[5px] font-bold text-[15px]"
          htmlType="submit"
          loading={mutation.isLoading}
        >
          Save Changes
        </Button>
      </Form>
    </Modal>
  );
};

export default CategoryModal;
